import { createAction } from "redux-act";

export const REQNotificationList = createAction("REQUEST_NOTIFICATION_LIST");
export const RESNotificationList = createAction("RECEIVE_NOTIFICATION_LIST");
export const FailNotificationList = createAction("FAILED_NOTIFICATION_LIST");
export const SENDxNotification = createAction("SEND_NOTIFICATION_NOW");
export const DELxNotification = createAction("DELETE_NOTIFICATION");
export const SETxNotificationStatus = createAction("SET_NOTIFICATION_STATUS");
export const CleanUpNotificationList = createAction("CLEANUP_NOTIFICATION_LIST");
